import { createContext, useContext } from 'react';

export type SidebarContextType = {
  closeMenu: () => void;
};

export const SidebarContext = createContext<SidebarContextType>({ closeMenu: () => undefined });

export const useSidebarContext = () => useContext(SidebarContext);
